const template = {
    name: "Default NEC4 ECC v4.1 24/03/2025",
    isSystemDefault: true,
    isGlobal: true,
    companies: [],
    resources: [
        {
            id: 1,
            type: "TEXT",
            key: "SUPPLIER_NAME",
            value: "Contractor"
        },
        {
            id: 2,
            type: "TEXT",
            key: "SUPPLIER_ABBREVIATION",
            value: "CON"
        },
        {
            id: 3,
            type: "TEXT",
            key: "PM_NAME",
            value: "Project Manager"
        },
        {
            id: 4,
            type: "TEXT",
            key: "PM_ABBREVIATION",
            value: "PM"
        },
        {
            id: 5,
            type: "TEXT",
            key: "SUPERVISOR_NAME",
            value: "Supervisor"
        },
        {
            id: 6,
            type: "TEXT",
            key: "SUPERVISOR_ABBREVIATION",
            value: "SUP"
        },
        {
            id: 7,
            type: "TEXT",
            key: "CLIENT_NAME",
            value: "Client"
        },
        {
            id: 8,
            type: "NUMBER",
            key: "SUPPLIER_REPLY_PERIOD",
            value: 14
        },
        {
            id: 9,
            type: "NUMBER",
            key: "PM_REPLY_PERIOD",
            value: 14
        },
        {
            id: 10,
            type: "NUMBER",
            key: "QUOTE_DURATION",
            value: 21
        },
        {
            id: 13,
            type: "NUMBER",
            key: "REQUOTE_DURATION",
            value: 21
        },
        {
            id: 11,
            type: "NUMBER",
            key: "QUOTE_RESPONSE",
            value: 14
        },
        {
            id: 14,
            type: "NUMBER",
            key: "REQUOTE_RESPONSE",
            value: 14
        },
        {
            id: 12,
            type: "NUMBER",
            key: "VARIATION_RESPONSE",
            value: 7
        },
        {
            id: 16,
            type: "NUMBER",
            key: "PROGRAMME_REPLY_PERIOD",
            value: 14
        },
        {
            id: 18,
            type: "TEXT",
            key: "COMPLETION_DATE",
            value: "Completion Date"
        },
        {
            id: 28,
            type: "NUMBER",
            key: "PROP_QUOTE_DURATION",
            value: 21
        },
        {
            id: 29,
            type: "NUMBER",
            key: "PROP_REQUOTE_DURATION",
            value: 21
        },
        {
            id: 27,
            type: "NUMBER",
            key: "SUPERVISOR_REPLY_PERIOD",
            value: 14
        },
        {
            id: 39,
            type: "TEXT",
            key: "CEN_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 40,
            type: "NUMBER",
            key: "CEN_DEEMED_ACCEPTANCE",
            value: 14
        },
        {
            id: 10,
            type: "TEXT",
            key: "QUOTE_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 25,
            type: "NUMBER",
            key: "QUOTE_DEEMED_ACCEPTANCE",
            value: 14
        },
        {
            id: 41,
            type: "TEXT",
            key: "PROG_DEEMED_ACCEPTANCE_STARTS",
            value: "RELATED_NOTICE"
        },
        {
            id: 42,
            type: "NUMBER",
            key: "PROG_DEEMED_ACCEPTANCE",
            value: 7
        }
    ],
    workflowGroups: [
        {
            id: 101,
            title: "Early Warnings",
            workflows: [
                {
                    id: 1,
                    title: "$PM_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$PM_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 2,
                    title: "$SUPPLIER_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 3,
                    title: "Early Warning Register",
                    notificationName: "Early Warning",
                    abbreviation: "Warning",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "MeetingRequiredLabel",
                            display: "Is an early warning meeting required?",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotificationClause",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "RiskItemsLabel",
                            display: "You are given warning of an occurrence/situation which may",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "DescriptionLabel",
                            display: "Description",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "RiskStatusLabel",
                            display: "Risk status",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskTypes",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "riskincreaseprice",
                            display: "increase the total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "riskdelaycompletion",
                            display: "delay Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "riskdelaymilestone",
                            display: "delay meeting a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "riskimpairperformance",
                            display: "impair the performance of the works in use",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "riskaffectmodel",
                            display: "adversely affect the creation or use of the Information Model",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "riskotherpartner",
                            display: "affect the achievement of another Partner's objectives",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "riskincreasecontractorcost",
                            display: "increase the $SUPPLIER_NAME's total cost",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "riskenvironment",
                            display: "adversely affect the achievement of the Climate Change Requirements (X29.3)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "riskincreasedefinedcost",
                            display: "Increased Defined Cost",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: false,
                            field: "riskaffectsafety",
                            display: "Adversely affect the safety of the works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: false,
                            field: "riskcontractbreach",
                            display: "Result in a contract breach",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: false,
                            field: "riskaffectwork",
                            display: "Adversely impact the effectiveness of the works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: false,
                            field: "riskchangeprogramme",
                            display: "Affect the programme",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: false,
                            field: "riskservicetiming",
                            display: "Affect the timing of the service",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: false,
                            field: "riskserviceperformance",
                            display: "Impair the performance of the service",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskStatusOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Mitigated",
                            display: "Mitigated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotMitigated",
                            display: "Not mitigated",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "MeetingOptions",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "0",
                            display: "Extra meeting not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "To be discussed at next scheduled early warning meeting",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "You are instructed to attend an early warning meeting as follows",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Pm",
                            display: "$WF_1_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_2_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_74_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 102,
            title: "Instructions",
            workflows: [
                {
                    id: 4,
                    title: "$PM_NAME Instructions",
                    notificationName: "Instruction",
                    abbreviation: "$PM_ABBREVIATION-Instruction-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "InstructionTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "14.3 to change the Scope or a Key Date",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "17.1 stating how to resolve an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "17.2 to change the Scope to remove something which is illegal or impossible",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "19.1 on how to deal with a prevention event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "23.1 to submit particulars of design of an item of Equipment",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "24.2 to remove a person",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "32.2 to submit a revised programme",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_14",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "34.1 to stop or not start work or to start or restart work",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "36.1 to submit a quotation for acceleration",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_19",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "40.3 to correct a failure to comply with the quality plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "60.6 to correct a mistake in the Bill of Quantities (main Options B and D)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "62.1 to submit alternative quotations for a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "73.1 on how to deal with an object of value of historical interest",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "92.2 to leave Site, remove Equipment, Plant and Materials and assign the benefit of the subcontract to the Client",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X10.4 to submit a revised Information Execution Plan",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "X12.1(6) providing Partnering Information",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "X22.4 to remove a key person during Stage One",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X22.5(2) to remove work required in Stage Two from the Scope",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "X29.4(4) to submit a revised climate change plan",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "Other Instruction",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Resources",
                    values: []
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_4_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_61_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Client",
                            display: "$WF_56_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 103,
            title: "Compensation Events",
            workflows: [
                {
                    id: 5,
                    title: "$PM_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-Compensation-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 6,
                    title: "$PM_NAME Proposed Instructions",
                    notificationName: "Proposed Instruction",
                    abbreviation: "$PM_ABBREVIATION-PROP-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 7,
                    title: "$SUPPLIER_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Compensation-",
                    notify: true,
                    replyEnabled: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "VARIATION_RESPONSE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 8,
                    title: "$PM_NAME CE Assessments",
                    notificationName: "Assessment of Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-CE-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 9,
                    title: "$PM_NAME Extension Requests",
                    notificationName: "Extension Request",
                    abbreviation: "$PM_ABBREVIATION-Extension-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ORIGINAL_DATE",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 10,
                    title: "$SUPPLIER_NAME Extension Requests",
                    notificationName: "Extension Request",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Extension-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ORIGINAL_DATE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 11,
                    title: "Master Quote Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 12,
                    title: "Master CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 13,
                    title: "Implemented CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmAssumptionLabel",
                            display: "In accordance with clause 61.6, your quotation is to be based on following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmAssumptionNote",
                            display: "You are instructed to provide a quote by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierDescNote",
                            display: "In accordance with clause 61.3, you are notified of the following as a compensation event:",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "ReplyAcceptedCommentLabel",
                            display: "In accordance with clause 61.4 you are notified of the $PM_NAME's decision that the notified matter is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "ReplyRejectedCommentLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionLabel",
                            display: "In accordance with clause 61.6, your quotation is to be based on following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "QuoteNote",
                            display: "In accordance with clause 62.3 please find attached a quotation for $reference.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "ExtensionPMLabel",
                            display: "An extension is required to the period for reply as detailed below.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ExtensionSupplierLabel",
                            display: "An extension is required to the period for producing a quotation as detailed below.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "AssessmentDetailLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ProposedInstructionNote",
                            display: "You are instructed to provide a quote by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "ProposedInstructionLabel",
                            display: "In accordance with clause 61.6, your quotation is to be based on following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "ReplyRejectedOptionsLabel",
                            display: "In accordance with clause 61.4 you are notified of the $PM_NAME's decision that the notified matter is not a compensation event as it",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "QuoteCostEffectLabel",
                            display: "Impact on total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "QuoteDateEffectLabel",
                            display: "Effect on the $COMPLETION_DATE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "QuoteDaysEffectLabel",
                            display: "Impact on the $COMPLETION_DATE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "AssessmentCostEffectLabel",
                            display: "Impact on total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "AssessmentDaysEffectLabel",
                            display: "Impact on the $COMPLETION_DATE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "QuoteProgrammeAttachLabel",
                            display: "Are you attaching a programme showing the effect against the last Accepted Programme?",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "CompensationTypeLabel",
                            display: "Compensation event type",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "AssessmentCompensationLabel",
                            display: "Compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "AssessmentWarningBanner",
                            display: "The $PM_NAME only makes an assessment: if the $SUPPLIER_NAME has not submitted a quotation in the time allowed; if the $PM_NAME decides that a quotation is not assessed correctly and notifies the $SUPPLIER_NAME that the $PM_NAME will assess; if the $SUPPLIER_NAME has not submitted a programme or updated the programme by the time stated in the contract; or the latest submitted programme has not been accepted.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "PmCompensationWarningBanner",
                            display: "If the $PM_NAME decides that the $SUPPLIER_NAME did not give an early warning, the $PM_NAME must immediately issue a notice to that effect using the 'Notification Workflow'.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "InstructionQuoteReplyWarningBanner",
                            display: "If the quotation is accepted, the $PM_NAME issues a relevant instruction using the \"$PM_NAME Instructions\" workflow.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "QuoteNoteProposedInstruction",
                            display: "We submit our quotation for proposed compensation event $reference.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "QuoteContinuingEffectLabel",
                            display: "Does this Claim have a continuing effect (i.e. is this an Interim Claim)?",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "SupplierCompensationWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "SupplierClaimWithQuotationWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "SupplierQuoteWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "QuoteReplyWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "SupplierClaimsWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "SupplierCompensationReplyWarningBanner",
                            display: "If the $PM_NAME decides that the $SUPPLIER_NAME did not give an $WF_2_NOTIFICATION_NAME, the $PM_NAME must state that in their reply.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "ClientCompensationWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "CenReplyMissingDueToDeemAcceptance",
                            display: "Reply not received. In the absence of a reply the notice was treated as accepted in accordance with the terms of the contract.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionNote",
                            display: "You instructed to submit a quotation by $date.",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "60.1(1) An instruction to change the Scope",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "60.1(2) $CLIENT_NAME does not provide access to the Site",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "60.1(3) $CLIENT_NAME does not provide something that it is to provide",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "60.1(4) An instruction to stop or not start work or to change a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "60.1(5) $CLIENT_NAME or Others do not work within the stated constraints",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "60.1(6)$PM_NAME or $SUPERVISOR_NAME does not reply to a communication",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "60.1(7) An instruction dealing with an object of interest or value",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "60.1(8) Change of a decision",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "60.1(9) Withholds an acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "60.1(10) An instruction to search for a Defect and no Defect is found",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "60.1(11) A test or inspection causes unnecessary delay",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "60.1(12)$SUPPLIER_NAME encounters physical conditions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "60.1(13) A weather measurement is recorded",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "60.1(14) An event which is the $CLIENT_NAME's liability",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "60.1(15)$PM_NAME certifies Take Over before Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "60.1(16) $CLIENT_NAME does not provide material for testing",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "60.1(17) Notification of a correction",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "60.1(18) A breach by the $CLIENT_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "60.1(19) A prevention event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "60.1(20) A notification that a quotation for a proposed instruction is not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "",
                            display: "60.1(21) Additional compensation events stated in the Contract Data and identified below",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "",
                            display: "60.4 A difference between the final total quantity of an item and the quantity in the Bill of Quantities which delays completion (main Options B and D)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "",
                            display: "60.5 A difference between the final total quantity of an item and the quantity in the Bill of Quantities (main Options B and D)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "",
                            display: "60.6 Correction of a mistake in the Bill of Quantities caused by a departure in the method of measurement",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "",
                            display: "X2.1 A change in the law",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "",
                            display: "X12.3(7) A change in the Partnering Information",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "",
                            display: "X14.2 Delay in making advanced payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "",
                            display: "X15.2 Correcting a Defect for which the $SUPPLIER_NAME is not liable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "",
                            display: "Y2.5 Suspension of performance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProposedInstructionClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "65.1 Proposed instruction",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "APMA",
                            display: "Quotation not accepted - awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ARQ",
                            display: "Quotation not accepted - awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "AM",
                            display: "Assessment made",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "QA",
                            display: "Quote accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "APMRQ",
                            display: "Awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "APMR",
                            display: "Awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "AQ",
                            display: "Awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NC",
                            display: "Not communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "R",
                            display: "Not a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DNG",
                            display: "Proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ADAQ",
                            display: "Awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "DA",
                            display: "Quotation treated as accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "ADAN",
                            display: "Awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "0",
                            display: "Not accepted - revised quotation required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "Awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "3",
                            display: "Not accepted - $PM_NAME will be making an assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "4",
                            display: "Not accepted - other quotation approved",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "5",
                            display: "Not accepted - proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "6",
                            display: "Awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "7",
                            display: "Treated as accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "none",
                            display: "Not communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "8",
                            display: "Acknowledged",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "9",
                            display: "Not accepted - process ended",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "10",
                            display: "Assessed",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "faultpscp",
                            display: "arises from a fault of the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "notexpectnothappen",
                            display: "has not happened and is not expected to happen",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "notnotifiedwithintimescales",
                            display: "has not been notified within the timescales set out in the contract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "noteffectcostcompletion",
                            display: "has no effect on Defined Cost, Completion or meeting a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "statedcontract",
                            display: "is not one of the compensation events stated in the contract",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyProceedOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "61.1",
                            display: "Proceed with works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "61.2",
                            display: "Do not proceed with works",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyProceedEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "InstructionReplyProceedEnabled",
                            display: "Proposed instructions Quote Reply field proceed options Enabled/Disabled",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "QuoteStatus_1",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "QuoteStatus_0",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "3",
                            display: "QuoteStatus_3",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "5",
                            display: "QuoteStatus_5",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteProgrammeImpactOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "noeffect",
                            display: "There is no effect on the $COMPLETION_DATE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "mitigated",
                            display: "There is an effect on the $COMPLETION_DATE but this has been mitigated by measures as detailed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "notmitigated",
                            display: "There is an effect on the $COMPLETION_DATE which we are unable to mitigate",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "OverdueExtensionsEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "OverdueExtensionsEnabled",
                            display: "Active-Inactive state indicates whether or not a PM or Supplier extension request can be accepted after the due date ",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "EWRelationEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "EWRelationEnabled",
                            display: "Active-Inactive state indicates whether the EWN can be attached in CEN communications",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RelatedCompensationText",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "RelatedCompensationText",
                            display: "Regarding the aforementioned instruction, you are notified that this is a compensation event.",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCompensationAQ",
                            display: "$WF_5_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmCompensationARQ",
                            display: "$WF_5_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "PmCompensationAPMRQ",
                            display: "$WF_5_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "PmCompensationAPMA",
                            display: "$WF_5_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SupCompensationAQ",
                            display: "$WF_7_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupCompensationARQ",
                            display: "$WF_7_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "SupCompensationAPMR",
                            display: "$WF_7_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "SupCompensationAPMRQ",
                            display: "$WF_7_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "SupCompensationAPMA",
                            display: "$WF_7_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "PmProposedAQ",
                            display: "$WF_6_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "PmProposedARQ",
                            display: "$WF_6_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "PmProposedAPMRQ",
                            display: "$WF_6_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "PmProposedAPMA",
                            display: "$WF_6_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "SupAssumption",
                            display: "$WF_42_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "SupClaimAPMR",
                            display: "$WF_37_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "SupClaimAQ",
                            display: "$WF_37_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "SupClaimARQ",
                            display: "$WF_37_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "SupClaimAPMRQ",
                            display: "$WF_37_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "SupClaimAPMA",
                            display: "$WF_37_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "replydraftpmcequotessupplier",
                            display: "$WF_7_TITLE quotations",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMR",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "COMPENSATION_CWN_AQ",
                            display: "$WF_67_TITLE awaiting reply awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "COMPENSATION_CWN_ARQ",
                            display: "$WF_67_TITLE awaiting reply awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMRQ",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMA",
                            display: "$WF_67_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_AQ",
                            display: "$WF_75_TITLE awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_ARQ",
                            display: "$WF_75_TITLE awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMR",
                            display: "$WF_75_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMRQ",
                            display: "$WF_75_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMA",
                            display: "$WF_75_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_AQ",
                            display: "$WF_76_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_ARQ",
                            display: "$WF_76_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMR",
                            display: "$WF_76_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMRQ",
                            display: "$WF_76_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 37,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMA",
                            display: "$WF_76_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "PmExtension",
                            display: "$WF_9_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "SupExtension",
                            display: "$WF_10_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationEventsAcceptanceOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "Is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "Is not a compensation event",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 104,
            title: "Programmes",
            workflows: [
                {
                    id: 14,
                    title: "$SUPPLIER_NAME Programme",
                    notificationName: "Programme",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Programme-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PROGRAMME_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "ReasonLabel",
                            display: "Reason for any change to Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ChangeLabel",
                            display: "Change in any other Key Date, Completion Date for a section or other important project milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "MainProgressLabel",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "KeyActivitiesLabel",
                            display: "Key activities forecast in next four weeks",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SummaryLabel",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ChangesLabel",
                            display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "CompensationLabel",
                            display: "Compensation events added to programme this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NotificationClause",
                            display: "Please find attached programme for acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ReplyRejectReasonLabel",
                            display: "The $SUPPLIER_NAME’s programme is not accepted for the following reasons",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "ReplyNotificationClause",
                            display: "You are notified that the $SUPPLIER_NAME’s programme",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "plansnotpractical",
                            display: "The $SUPPLIER_NAME’s plans which it shows are not practicable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "missingcontractrequires",
                            display: "It does not show the information which the contract requires",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "notrepresentplan",
                            display: "It does not represent the $SUPPLIER_NAME’s plans realistically",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "notcomply",
                            display: "It does not comply with the Scope",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DashboardDisplayPlannedCompletionOnLatest",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "DashboardDisplayPlannedCompletionOnLatest",
                            display: "Active-Inactive state indicates whether (Planned Completion shown on the latest Accepted Programme) is displayed on dasboard",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PreviousPlanned",
                            display: "Previous Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PlannedCompletion",
                            display: "Date of Planned Completion this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Reason",
                            display: "Reason for any change to Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Change",
                            display: "Change in any other Key Date, Sectional Completion or other important project milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "MainProgress",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "KeyActivities",
                            display: "Key activities forecast in next four weeks",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "Summary",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "Changes",
                            display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "Compensation",
                            display: "Compensation events added to programme this period",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedClauses",
                    values: [
                        {
                            id: 1,
                            wfid: 14,
                            isActive: true,
                            field: "",
                            display: "31.1 Submission of first programme (if not included in Contract Data)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 14,
                            isActive: true,
                            field: "",
                            display: "32.2 Submission of a revised programme",
                            overrideResources: null,
                            postActions: []
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 14,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 14,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 14,
                            isActive: false,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 14,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_14",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 14,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_14_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 105,
            title: "Notifications",
            workflows: [
                {
                    id: 15,
                    title: "$PM_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$PM_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                },
                {
                    id: 16,
                    title: "$SUPPLIER_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
                    }
                },
                {
                    id: 17,
                    title: "$SUPERVISOR_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$SUPERVISOR_NAME-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPERVISOR_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPERVISOR",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Supervisor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "PmClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.2 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "13.5 of an agreement to extend the period for reply for a communication (excluding compensation events periods)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "14.2 of the cancellation of a delegation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "16.2 that the $CLIENT_NAME is considering a proposal",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "17.1 of an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 14,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "17.2 of an illegal or impossible requirement",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 14,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 42,
                            isActive: true,
                            field: "",
                            display: "19.1 of a prevention event",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "25.2 of an assessment of the amount to be paid as the $SUPPLIER_NAME failed to provide services",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: false,
                            field: "",
                            display: "25.3 of the amount assessed for a failure to meet a Key Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "26.3 of an agreement that submission of Subcontractor documents is not needed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "27.2 to provide access to the work being done and Plant and Materials being stored to those named",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "28.1 on behalf of the $CLIENT_NAME of an intention to transfer the benefit of the contract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: false,
                            field: "",
                            display: "30.2 of certification of the date of Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: false,
                            field: "",
                            display: "35.3 of certification of the date of take over of part of the works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: false,
                            field: "",
                            display: "41.6 of an assessment of the amount to be paid for repeating a test or inspection",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: false,
                            field: "",
                            display: "45.1 of a proposal to accept a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "46.1 of the amount to be paid for uncorrected Defects",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "46.2 of the cost the $SUPPLIER_NAME would incur in correcting a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "50.9 of acceptance that part of the Defined Cost is correct (main Options C, D, E and F)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "50.9 of further records in respect of Defined Cost are needed (main Option C, D, E and F)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "50.9 of errors in the $SUPPLIER_NAME's assessment (main Option C, D, E and F)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "",
                            display: "50.9 of the correct assessment of the part of the Defined Cost (main Option C, D, E and F)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: false,
                            field: "",
                            display: "53.1 of certification of the final payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: false,
                            field: "",
                            display: "53.3 of the preliminary assessment of the $SUPPLIER_NAME's share (main Option C and D)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: false,
                            field: "",
                            display: "53.4 of the final assessment of the $SUPPLIER_NAME's share (main Option C and D)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "",
                            display: "61.5 that the $PM_NAME has decided the $SUPPLIER_NAME did not give early warning of a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "",
                            display: "61.6 that an assumption on which a compensation event quotation is based was wrong",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "",
                            display: "90.1 of a wish to terminate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: false,
                            field: "",
                            display: "90.1 of the issue of a termination certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "",
                            display: "91.2 of a default/of the $SUPPLIER_NAME having not put right a default",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "",
                            display: "91.3 of a default/of the $SUPPLIER_NAME having not put right a default",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "",
                            display: "92.2 that Equipment is no longer required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "",
                            display: "W1.1(1) on behalf of the Client, the name of a replacement Senior Representative",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "",
                            display: "X7.3 of the amount of reduction in delay damages following take over of part of the works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "",
                            display: "X18.6 of a matter for which the $SUPPLIER_NAME is liable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 41,
                            isActive: true,
                            field: "",
                            display: "X22.5(1) of a notice to proceed to Stage Two",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 37,
                            isActive: false,
                            field: "",
                            display: "X22.6(2) of the assessment to the change in the Budget",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "",
                            display: "Y2.3 of an intention to pay less than the notified sum",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 39,
                            isActive: true,
                            field: "",
                            display: "Y3.3 on behalf of the $CLIENT_NAME of the name of the beneficiary",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 40,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupplierClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.2 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "17.1 of an ambiguity or inconsistency",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "17.2 of an illegal or impossible requirement",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 14,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "19.1 of a prevention event",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "20.3 of advice on the practical implications of the design and subcontracting arrangements (main Options C, D, E and F)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "28.1 of an intention to transfer the benefit of the contract",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "31.3 of a failure by the Project Manager to notify acceptance or non acceptance of a programme",
                            effect: "PROG_DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "50.9 of when the Defined Cost of part of the works has been finalised (main Options C, D, E and F)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "61.4 of a failure by the Project Manager to respond to a compensation event notification",
                            effect: "CEN_DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "62.6 of a failure by the Project Manager to respond to a quotation",
                            effect: "DEEM_START_INTERVAL",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "64.4 of a failure by the Project Manager to make an assessment of a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "73.1 that an object of value of of historical or other interest has been found",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_4",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "90.1 of a wish to terminate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "W1.1(1) of the name of a replacement Senior Representative",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "X10.4(2) of a failure by the Project Manager to notify acceptance or non acceptance of an Information Execution Plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "Y2.3 of an intention to pay less than the notified sum",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupervisorClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.2 of change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "14.2 of the cancellation of a delegation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "41.3 of a test or inspection or the result of a test or inspection",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "42.1 that Plant and Materials have passed a test or inspection",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "44.3 of the issue of the Defects Certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 4,
                            isActive: true,
                            field: "Client",
                            display: "$WF_57_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_15_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_16_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_17_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "PmToSupervisor",
                            display: "$WF_58_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "PmToClient",
                            display: "$WF_59_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "SupplierToSupervisor",
                            display: "$WF_81_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupervisorToPm",
                            display: "$WF_60_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ClientToClient",
                            display: "$WF_64_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "PmToPm",
                            display: "$WF_63_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "SupplierToSupplier",
                            display: "$WF_65_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "SupervisorToSupervisor",
                            display: "$WF_66_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 106,
            title: "Submissions",
            workflows: [
                {
                    id: 18,
                    title: "$SUPPLIER_NAME Submissions",
                    notificationName: "Submission",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Submission-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 49,
                    title: "$PM_NAME Submissions",
                    notificationName: "Submission",
                    abbreviation: "$PM_ABBREVIATION-Submission-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "IssueClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "16.1 a proposal to reduce the amount the $CLIENT_NAME pays to the $SUPPLIER_NAME",
                            applyReplyPeriod: true,
                            replyPeriod: 28,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "16.3 a proposal to add an area to the Working Area",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "20.4 forecasts of the total Defined Cost for the whole of the works (main Options C, D, E and F)",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "21.2 particulars of design",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "23.1 particulars of design for an item of Equipment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "24.1 details of a replacement person",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "26.2 the name of a proposed Subcontractor",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "26.3 proposed subcontract documents",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "26.4 pricing information in a proposed subcontract document (main Options C, D, E and F)",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "40.2 a proposed quality policy statement or quality policy plan",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "45.1 a proposal to accept a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "",
                            display: "50.9 records to demonstrate Defined Cost is correctly assessed (main Options C, D, E and F) (4 weeks reply)",
                            applyReplyPeriod: true,
                            replyPeriod: 28,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "50.9 further records to demonstrate Defined Cost is correctly assessed (main Options C, D, E and F) (13 weeks reply)",
                            applyReplyPeriod: true,
                            replyPeriod: 91,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "55.3 a revised activity schedule (main Option A)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "84.1 certificates of insurance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "X4.1 an ultimate holding company guarantee",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "",
                            display: "X9.1 documents which transfer rights to the Client",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 18,
                            isActive: true,
                            field: "",
                            display: "X10.4(1) an Information Execution Plan",
                            applyReplyPeriod: true,
                            replyPeriod: 14,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X10.4(3) a revised Information Execution Plan",
                            applyReplyPeriod: true,
                            replyPeriod: 14,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "X13.1 a performance bond",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "X14.2 an advance payment bond",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "",
                            display: "X15.1 a certificate of insurance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "",
                            display: "X16.3 a retention bond",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "",
                            display: "X20.2 a report of performance",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "",
                            display: "X20.3 proposals for improving performance",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "",
                            display: "X21.1 a proposal to reduce the cost of operating and maintaining an asset",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "",
                            display: "X22.1(1) of a forecast of the total Defined Cost for the work in Stage One",
                            applyReplyPeriod: true,
                            replyPeriod: 7,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "",
                            display: "X22.3(1) a design proposal for Stage Two",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "",
                            display: "X29.4(1) of a first climate change plan for acceptance",
                            applyReplyPeriod: true,
                            replyPeriod: 14,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "",
                            display: "X29.4(4) of a revised climate change plan for acceptance",
                            applyReplyPeriod: true,
                            replyPeriod: 14,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "",
                            display: "X29.11(1) of a proposal to change the Scope to reduce the impact on climate change",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 40,
                            isActive: true,
                            field: "",
                            display: "X29.12(1) of a report of performance against the targets in the Performance Table",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 42,
                            isActive: true,
                            field: "",
                            display: "X29.12(2) of a proposal for improving performance for acceptance",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "",
                            display: "Y1.4 details of the banking arrangement for the Project Bank Account",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "",
                            display: "Y1.6 a proposal to add a Supplier to the Named Suppliers",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "",
                            display: "Y1.9 the Authorisation setting out sums due to the Named Suppliers",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "",
                            display: "Other submission",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "IssueClausesPM",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "45.1 a proposal to accept a Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "86.1 of certificates of insurance provided by the Client",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "ReplyWarningBanner",
                            display: "Please note a reason must be given and that if it is not a reason in the contract then it is a compensation event. If the reply is a rejection, we recommend that you add \"You are required to resubmit within the time stated in the contract\"",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 18,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 18,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 18,
                            isActive: false,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted (not used as resubmission is always required under 13.4 on all clauses apart from 45.1)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 18,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 14,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 18,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            wfid: 49,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            wfid: 49,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_49",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 10,
                            wfid: 49,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_18_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_49_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 107,
            title: "Submissions (with quotation)",
            workflows: [
                {
                    id: 19,
                    title: "$SUPPLIER_NAME Submissions (wq)",
                    notificationName: "Submission",
                    abbreviation: "$SUPPLIER_ABBREVIATION-SubmissionWQ-",
                    notify: true,
                    replyEnabled: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CostEffectLabel",
                            display: "Impact on total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "DaysEffectLabel",
                            display: "Impact on the $COMPLETION_DATE",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProposalClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "36.1 of a quotation for acceleration",
                            applyReplyPeriod: true,
                            replyPeriod: 21,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "45.2 of a quotation to accept a Defect",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "50.9 of a quotation for adjustment to the Prices due to Defined Cost for a part of the works having been finalised [Option C/D/E/F]",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "X21.1 a quotation to reduce the cost of operating and maintaining an asset",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "X22.3(2) of the total of the Prices for Stage Two",
                            applyReplyPeriod: false,
                            noReply: true,
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "X29.11(2) of a quotation for a change to reduce the impact on climate change",
                            applyReplyPeriod: false,
                            noReply: false,
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_19_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 19,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 19,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 19,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 19,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_19",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 19,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 116,
            title: "Forecast",
            workflows: [
                {
                    id: 52,
                    title: "Cost Forecast",
                    notificationName: "Cost Forecast",
                    abbreviation: "$SUPPLIER_ABBREVIATION-CF-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CostForecastWarningBanner",
                            display: "The forecast is to be submitted at the interval stated in the Contract Data and in the format included in the Scope. Outturn cost should incorporate payment information received to date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "CarbonForecastWarningBanner",
                            display: "The forecast is to be submitted at the interval stated in the Contract Data for Defined Cost forecast and in the format included in the Scope.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "TargetLabel",
                            display: "Target",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "ForecastLabel",
                            display: "Forecast",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "ActualLabel",
                            display: "Actual",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "VarianceLabel",
                            display: "Variance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CostForecastClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "NEC 4 ECC Option C - as per Clause 20.4",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "NEC 4 ECC Option E - as per Clause 20.4",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CarbonForecastClauses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "NEC4 PSC - whole life carbon of the proposed solution",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "NEC4 ECC - capital carbon of the built solution",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CostForecastClausesEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "CostForecastClausesEnabled",
                            display: "Active-Inactive state indicates \"Type\" field will be included in registers and and communication forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CarbonForecastClausesEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "CarbonForecastClausesEnabled",
                            display: "Active-Inactive state indicates \"Type\" field will be included in registers and communication forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "Target",
                            display: "Target",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Forecast",
                            display: "Forecast",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Actual",
                            display: "Actual",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Variance",
                            display: "Variance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 108,
            title: "Payments",
            workflows: [
                {
                    id: 21,
                    title: "$SUPPLIER_NAME Payment Applications",
                    notificationName: "Payment Application",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Payment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 20,
                    title: "$PM_NAME Payment Certificates",
                    notificationName: "Payment Certificate",
                    abbreviation: "$PM_ABBREVIATION-Payment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CumulativePriceLabel",
                            display: "Price for Work Done to Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PlusAmountsSupplierLabel",
                            display: "Plus other amounts to be paid to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "LessAmountsSupplierLabel",
                            display: "Less amounts to be paid by or retained from the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TaxSupplierLabel",
                            display: "Tax which the law requires the Employer to pay to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "WarningBanner",
                            display: "The first assessment date is no later than the assessment interval after the starting date. Subsequent assessment dates are the assessment interval after the previous assessment. Assessments continue until the Supervisor issues the Defects Certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "RegisterAppliedByCaption",
                            display: "Submitted by",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "SummaryDetailsLabel",
                            display: "Summary details",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaxEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "TaxEnabled",
                            display: "Active-Inactive state indicates tax field will be included in notification forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PaymentTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "INTERIM",
                            display: "51.1 Interim assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "FINAL",
                            display: "53.1 Final assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "SUPPLEMENTARY",
                            display: "Supplementary",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ApplicationTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "INTERIM",
                            display: "50.2 application for payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "COMPLETION",
                            display: "Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "FINAL",
                            display: "53.2 assessment of the final amount due",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "TERMINATION",
                            display: "Termination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "SUPPLEMENTARY",
                            display: "Supplementary",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "DRAFT",
                            display: "Draft",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "EXTRA",
                            display: "Extra",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "OTHER",
                            display: "Other",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "MandateAttachment",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "MandateAttachment",
                            display: "Active-Inactive state indicates whether attachment is mandatory on Payment Application and Certifications",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PONumberEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "PONumberEnabled",
                            display: "Purchase Order number field will be included in notification forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 119,
            title: "Other PM Assessments (excluding CE's)",
            workflows: [
                {
                    id: 77,
                    title: "$PM_NAME Assessments (excluding CE's and Payments)",
                    notificationName: "Assessment",
                    abbreviation: "$PM_ABBREVIATION-Other-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "ActionReminders",
                    values: []
                },
                {
                    replacementKey: "FieldsPM",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Subject",
                            display: "Subject",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Type",
                            display: "Type",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Description",
                            display: "Description",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "EffectContractPrice",
                            display: "Affect contract price",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "Amount",
                            display: "Amount",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "EffectContractCompletion",
                            display: "Affect contract date(s)",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "Days",
                            display: "Time (days)",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClausesPM",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "25.2 Cost incurred by the $CLIENT_NAME as a result of $SUPPLIER_NAME not providing the services and/or other things",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "",
                            display: "25.3 Additional cost which the $CLIENT_NAME has paid or will incur due to the work not meeting the Condition stated for a Key Date",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "41.6 Cost incurred by $CLIENT_NAME in repeating a test or inspection after a Defect is found",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "46.1 Cost to $CLIENT_NAME of having a Defect corrected by others",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "46.2 Cost the $SUPPLIER_NAME would have incurred in correcting a Defect had they been able to gain access to correct the Defect",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "53.3 Preliminary assessment of the $SUPPLIER_NAME's share [Option C]",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: false,
                            field: "",
                            display: "53.4 Final assessment of the $SUPPLIER_NAME's share [Option C]",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: false,
                            field: "",
                            display: "54.7 Preliminary assessment of the $SUPPLIER_NAME's share [Option D]",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: false,
                            field: "",
                            display: "54.8 Final assessment of the $SUPPLIER_NAME's share [Option D]",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "93.4 the $SUPPLIER_NAME's share after termination [Option C]",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "93.5 the $SUPPLIER_NAME's share after termination [Option D]",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "",
                            display: "X1.4 Price adjustment for inflation [Option A/B]",
                            effect: "EFFECT_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "",
                            display: "X7.1 Delay damages",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "",
                            display: "X7.2 Interest to be paid by the $CLIENT_NAME on overpayment of damages",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "",
                            display: "X7.3 The reduction in delay damages if the $CLIENT_NAME takes over a part of the works before Completion",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "",
                            display: "X22.6 Change to the Budget",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "",
                            display: "X22.7(2) Preliminary assessment of the budget incentive at Completion of the whole of the works",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "",
                            display: "X22.7(3) Final assessment of the budget incentive",
                            effect: "NOEFFECT_COMPLETION_PRICE",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 117,
            title: "Other Certificates (excluding Payments)",
            workflows: [
                {
                    id: 68,
                    title: "$PM_NAME Certificates",
                    notificationName: "Certificate",
                    abbreviation: "$PM_ABBREVIATION-Certificate-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 71,
                    title: "$SUPERVISOR_NAME Certificates",
                    notificationName: "Certificate",
                    abbreviation: "$SUPERVISOR_ABBREVIATION-Certificate-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPERVISOR_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPERVISOR",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Supervisor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"PM\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupplierCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "ClientCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "SupervisorCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Incomplete works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Uncorrected Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SectionalCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Sectional Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TakingOverFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Taking Over Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DefectsFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Incomplete works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Uncorrected Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TerminationFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "OtherFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaskOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProjectOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Not Accepted",
                            display: "Not Accepted",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PMCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "30.2 Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "30.2 (X5.1) Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "35.3 Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "90.1 Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 91,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_20",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "Certificate of Partner's achievements in the pre-project assessment phase 1 (including Phase 1 incentive amount)",
                            effect: "OTHER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupervisorCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "",
                            display: "Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "",
                            display: "Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "44.3 Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 28,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_20",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "",
                            display: "Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "Other Certificate",
                            effect: "OTHER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionChangesStateEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CompletionChangesStateEnabled",
                            display: "Indicate whether communication of a Completion Certificate should change the contract state",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_68_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_69_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_70_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_71_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 109,
            title: "Quality Management",
            workflows: [
                {
                    id: 22,
                    title: "$SUPERVISOR_NAME Instructions to Search",
                    notificationName: "Instruction to Search",
                    pageTitle: "$SUPERVISOR_NAME Instruction to Search",
                    abbreviation: "Search-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "NOTIFICATION_DATE",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPERVISOR",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Supervisor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"PM\"]]"
                    }
                },
                {
                    id: 23,
                    title: "$SUPERVISOR_NAME Defect Notifications",
                    notificationName: "Defect Notification",
                    pageTitle: "$SUPERVISOR_NAME Defect Notification",
                    abbreviation: "$SUPERVISOR_NAME-Defect-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Supervisor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"PM\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 24,
                    title: "$SUPPLIER_NAME Defect Notifications",
                    notificationName: "Defect Notification",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Defect-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"PM\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 25,
                    title: "$SUPPLIER_NAME Tests & Inspections",
                    notificationName: "Test / Inspection",
                    abbreviation: "Test-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "NOTIFICATION_DATE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"PM\"]]"
                    }
                },
                {
                    id: 47,
                    title: "$SUPERVISOR_NAME Tests & Inspections",
                    notificationName: "Test / Inspection",
                    abbreviation: "$SUPERVISOR_NAME-Test-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "NOTIFICATION_DATE",
                    replyPeriod: 0,
                    notifyingParty: "SUPERVISOR",
                    replyingParty: "SUPERVISOR",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Supervisor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"PM\"]]"
                    }
                },
                {
                    id: 26,
                    title: "Master Defect Register",
                    notificationName: "Defect Notification",
                    abbreviation: "Defect",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "InstructionClauseLabel",
                            display: "Under clause 43.1, you are instructed to search for a Defect as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupervisorClauseLabel",
                            display: "Under clause 43.2, you are notified of a Defect as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierClauseLabel",
                            display: "Under clause 43.2, you are notified of a Defect as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TestsClauseLabel",
                            display: "Under clause 41.3, I am informing you of a test or inspection as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "DefectsWarningBanner",
                            display: "A Defect is not notified after the defects date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SearchWarningBannerDate",
                            display: "An instruction to search for a Defect is not to be issued after the defects date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "SearchWarningBannerDetails",
                            display: "Reasons for the search must be included.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NCProposalReplyWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "NCProposalNote",
                            display: "Z5.2(1) Proposal to treat a Defect as a Non-Conformity. Response will be required by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "ClosureReasonLabel",
                            display: "Reason for closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "InstructionTypeLabel",
                            display: "Type",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClosureReasonOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Corrected",
                            display: "Corrected",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "NoDefect",
                            display: "Not a Defect",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DefectPlannedClosureEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "DefectPlannedClosureEnabled",
                            display: "Active-Inactive state indicates \"Defect Planned Closure Date\" field will be included in registers, reports and actions tab",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedClauses",
                    values: [
                        {
                            id: 3,
                            wfid: 22,
                            isActive: true,
                            field: "",
                            display: "43.1 Instruction to Search for a Defect",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_24",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 1,
                            wfid: 23,
                            isActive: true,
                            field: "",
                            display: "43.2 Notification of a Defect",
                            overrideResources: null,
                            postActions: []
                        },
                        {
                            id: 2,
                            wfid: 24,
                            isActive: true,
                            field: "",
                            display: "43.2 Notification of a Defect",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Instruction",
                            display: "$WF_22_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SuperDefect",
                            display: "$WF_23_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "SupplierDefect",
                            display: "$WF_24_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Inspection",
                            display: "$WF_25_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "SupervisorTestAndInspection",
                            display: "$WF_47_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "PMTestAndInspection",
                            display: "$WF_48_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "PMNCProposal",
                            display: "$WF_54_TITLE awaiting acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "NonConformity",
                            display: "$WF_55_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 110,
            title: "Delegations",
            workflows: [
                {
                    id: 27,
                    title: "$PM_NAME Delegations",
                    notificationName: "Delegation",
                    abbreviation: "$PM_ABBREVIATION-Delegation-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 29,
                    title: "$SUPERVISOR_NAME Delegations",
                    notificationName: "Delegation",
                    abbreviation: "$SUPERVISOR_NAME-Delegation-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPERVISOR",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Supervisor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "DelegationClause",
                            display: "You are notified that the following actions",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "AllowCrossPartyDelegations",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "AllowCrossPartyDelegations",
                            display: "Set this to allow the sender to delegate to any contract user irrespective of which party the user is assigned to",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 111,
            title: "Records",
            workflows: [
                {
                    id: 30,
                    title: "$PM_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$PM_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 31,
                    title: "$SUPPLIER_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 32,
                    title: "$SUPPLIER_NAME Site Diary",
                    notificationName: "Site Diary",
                    abbreviation: "Diary-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 33,
                    title: "Weather",
                    notificationName: "Weather",
                    abbreviation: "Weather-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: []
        },
        {
            id: 112,
            title: "RFI's / TQ's",
            workflows: [
                {
                    id: 80,
                    title: "$PM_NAME RFI / TQ",
                    notificationName: "RFI / TQ",
                    abbreviation: "$PM_ABBREVIATION-RFITQ-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
                    }
                },
                {
                    id: 34,
                    title: "$SUPPLIER_NAME RFI / TQ",
                    notificationName: "RFI / TQ",
                    abbreviation: "$SUPPLIER_NAME-RFITQ-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 82,
                    title: "Master RFI / TQ Register",
                    notificationName: "RFI / TQ",
                    abbreviation: "RFI/TQ-",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_34_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_80_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 113,
            title: "Contract Information",
            workflows: [
                {
                    id: 39,
                    title: "Documents",
                    notificationName: "Document",
                    abbreviation: "Documents-",
                    notify: true,
                    actioningParty: "PM",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        actionTab: {
                            actionFilter: "[[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: []
                }
            ]
        }
    ]
};
export default template;